import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-43" data-mp="1lc20peakr5rp">
      <div className="mx-auto max-w-3xl" data-id="element-44" data-mp="1ge0jz00mfije">
        <h2 className="text-center font-display text-3xl uppercase text-cream sm:text-5xl" data-id="element-45" data-mp="2e0fxjqpxfw1o">
          Questions <span className="text-gold" data-id="element-46" data-mp="291d2mz3nv67f">fréquentes</span>
        </h2>
        <div className="mt-10 divide-y divide-line border-y border-line" data-id="element-47" data-mp="2924mxdrt5hie">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-48" data-mp="1z25i9ryiebat" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-4 text-left text-base font-semibold sm:py-5 sm:text-lg text-cream" data-id="element-49" data-mp="1z2x8sod91iu8">
                  {f.q}
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden data-id="element-50" data-mp="pg3gs6tbcbqc" />
                </button>
                <AnimatePresence initial={false} data-id="element-51" data-mp="ki1yho3pogfx">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-52" data-mp="6rq0j8kg3ngv">
                      <p className="pb-5 text-mute" data-id="element-53" data-mp="1q93xp8zun63">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}